import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  template: `
    <div class="flex flex-column align-items-center justify-content-center p-8 text-center fadein">
      <div class="empty-state-icon mb-4">
        <svg width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="var(--primary-200)" stroke-width="1.5"/>
          <path d="M12 2C12 2 15 5 15 12C15 19 12 22 12 22" stroke="var(--primary-200)" stroke-width="1.5"/>
          <path d="M12 2C12 2 9 5 9 12C9 19 12 22 12 22" stroke="var(--primary-200)" stroke-width="1.5"/>
          <path d="M2 12H22" stroke="var(--primary-200)" stroke-width="1.5"/>
          <circle cx="12" cy="12" r="3" fill="var(--primary-50)" stroke="var(--primary-400)" stroke-width="1.5"/>
          <path d="M10.5 10.5L13.5 13.5" stroke="var(--primary-600)" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M13.5 10.5L10.5 13.5" stroke="var(--primary-600)" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </div>
      <h2 class="text-2xl font-bold text-900 mb-2">{{ title }}</h2>
      <p class="text-600 max-w-20rem mx-auto mb-4">{{ description }}</p>
      <ng-content></ng-content>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
    .empty-state-icon {
      filter: drop-shadow(0 10px 15px rgba(0,0,0,0.05));
    }
  `]
})
export class EmptyStateComponent {
  @Input() title: string = 'Žádná data k dispozici';
  @Input() description: string = 'Zatím zde nejsou žádné záznamy k zobrazení.';
}
